import * as React from 'react'
import MuiAlert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import LinearProgress from '@mui/material/LinearProgress'
import CircularProgress from '@mui/material/CircularProgress'
import { styled, useTheme } from '@mui/material/styles'
import StackContext from '../contexts/stackContext'

const _Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})
const Alert = styled(_Alert)(
  ({ theme }) => `
  .MuiAlert-message {
    width: 100%;
  }

  .MuiLinearProgress-bar {
    background-color: ${theme.palette.primary.contrastText};
  }
`,
)

export interface ToastProps {
  message: string
  toastId: string
}

export default function UplaodToast(props: ToastProps) {
  const { toastId, message } = props
  const [open, setOpen] = React.useState(true)
  const [finishing, setFinishing] = React.useState(false)
  const stack = React.useContext(StackContext)
  const theme = useTheme()
  const progress = stack?.getUploads?.()?.find?.(({ id }) => id === toastId)?.progress

  React.useEffect(() => {
    if (stack?.getUploads?.()?.find(({ id }) => id === toastId)?.progress === 100) {
      // setFinishing(true)
      setOpen(false)
      stack.setToasts((stack) => stack.filter((toast) => toast.props.toastId !== toastId))
      // stack.addToast('Upload completed.', 5000, 'success')
    }
  }, [progress])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
    stack.setToasts((stack) => stack.filter((toast) => toast.props.toastId !== toastId))
  }

  return (
    <React.Fragment>
      <Snackbar
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ width: '50%', minWidth: '400px' }}
        style={{ zIndex: 999999, position: 'relative' }}
      >
        <Alert onClose={handleClose} sx={{ width: '100%' }} severity="info">
          {message}

          {!finishing && <LinearProgress variant="determinate" value={progress} />}
          {finishing && (
            <CircularProgress
              size={30}
              sx={{ position: 'absolute', top: '8px', right: '50px', color: theme.palette.primary.contrastText }}
            />
          )}
        </Alert>
      </Snackbar>
    </React.Fragment>
  )
}
